import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_suits: FaireCategoryEntity = {
  token: "cat_women-suits",
  type: "category",
  name: "Suits & blazers",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/suits-blazers",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
